<template>
  <ChecklistBlockBase
    :buttonsPreset="'copy'"
    :buttonsData="editorMetadata.buttonsData"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <BaseDivider color="border-base-secondary" />
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";

export default {
  props: {
    block: Object,
    editorMetadata: Object
  },
  components: {
    ChecklistBlockBase,
  },
};
</script>

<style>
</style>